<app-header *ngIf="!activeFormulaE && !isIframePage"></app-header>
<main [ngClass]='activeFormulaE ? "pt-0" : ""' [class.no-padding]="isIframePage">
    <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!isIframePage"></app-footer>
<app-loading-global *ngIf='loading'></app-loading-global>
